export interface IKeyName {
    key: string;
    name: string;
    type: 'string' | 'date' | 'translatable' | 'hidden' | 'title';
    highlighted?: boolean;
    flex?: number;
}
